






















































































import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';

@Component
export default class SwButton extends SwExtendedVue {
  @Prop({ type: Boolean, default: false }) disabled: boolean;
  @Prop({ type: Boolean, default: false }) asDefault: boolean;
  @Prop({ type: String, default: 'light' }) theme : string;
  @Prop(String) name: string;
}
